import React, { useEffect, useState } from 'react';
import { post } from '../../Auths/AuthToken';
import Button from '../../Button';

function ViewCredentialingPopup({ close, id = '', editPopup }) {
  const [allData, setAllData] = useState({});

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/reports/managePayerMatrix/viewPayerMetrixPopup',
          {
            payerMatrixId: id,
          }
        );
        if (response.status === 200) {
          setAllData(response?.data);
        }
      } catch (err) {
        console.error(err);
      }
    })();
  }, [id]);

  return (
    <div id="payerMatrixPopup" className="modalBackground">
      <div className="bill-view-sectn-blk">
        <div className="view-sectn-blk">
          <span className="clear-left10">
            Payer Provider Matrix:{allData?.headerDetail || ''}
          </span>
          <Button variant="circle" onClick={close}>
            X
          </Button>
        </div>
        <div className="width100 pymnt-popup-inner-body">
          <fieldset>
            <legend>Payor Credentialing</legend>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val">
                <div className="post-pymnt-lbl">
                  Payer name:{/*<span className="required">*</span> */}
                </div>
                <div>
                  <div className="post-pymnt-val">{allData?.payerName}</div>
                </div>
              </div>
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">Application Status:</span>
                <span className="post-pymnt-val">
                  {allData?.applicationStatus}
                </span>
              </div>
            </div>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">
                  Rendering provider:{/*<span className="required">*</span> */}
                </span>
                <span className="post-pymnt-val">
                  {allData?.renderingProvider}
                </span>
              </div>
              <div className="post-pymnt-rw-val">
                <div
                  className="flex-sec"
                  style={{
                    gap: '25px',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <span className="post-pymnt-lbl">Submitted:</span>
                  <span className="post-pymnt-val">
                    <div>{allData?.submitted}</div>
                  </span>
                </div>
                <div
                  className="flex-sec"
                  style={{
                    gap: '10px',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <span className="post-pymnt-lbl">Follow-up:</span>
                  <span className="post-pymnt-val">{allData?.followUp}</span>
                </div>
              </div>
            </div>
            <div className="post-pymnt-rw">
              <div className="" style={{ display: 'flex', width: '100%' }}>
                <span className="post-pymnt-lbl">Attachment:</span>
                {allData?.payerAttachArr?.map((item, i) => (
                  <span
                    key={i}
                    className="gatewayblock-row"
                    style={{ border: '1px solid #dadada' }}
                  >
                    <a
                      href={item.path}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.fileName}
                    </a>
                  </span>
                ))}
              </div>
            </div>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val width100">
                <span className="post-pymnt-lbl">Note:</span>
                {allData?.application_note}
              </div>
            </div>
            <div className="dash-schedule-sep-dotted">&nbsp;</div>
            <div className="width100 qmed-common-bg">
              <div className="post-pymnt-rw">
                <div className="post-pymnt-rw-val">
                  <span className="post-pymnt-lbl">Approval:</span>
                  <span className="post-pymnt-val-calander">
                    {allData?.approval_date}
                  </span>
                </div>
              </div>
              <div className="post-pymnt-rw">
                <div className="pmsPopupinnerBodyrow post-pymnt-val">
                  <div className="" style={{ display: 'flex', width: '100%' }}>
                    <span className="post-pymnt-lbl">Attachment:</span>
                    {allData?.approvalAttachArr?.map((item, i) => (
                      <span key={i} className="post-pymnt-val">
                        <a
                          href={item.path}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.fileName}
                        </a>
                      </span>
                    ))}
                  </div>
                </div>
              </div>
              <div className="post-pymnt-rw">
                <div className="post-pymnt-rw-val width100">
                  <span className="post-pymnt-lbl">Note:</span>
                  <span className="post-pymnt-val">
                    {allData?.approval_note}
                  </span>
                </div>
              </div>
            </div>
            <div className="dash-schedule-sep-dotted">&nbsp;</div>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">Effective:</span>
                <span className="post-pymnt-val-calander">
                  {allData?.effective}
                </span>
              </div>
            </div>
            <div className="post-pymnt-rw">
              <div className="pmsPopupinnerBodyrow post-pymnt-val">
                <div className="" style={{ display: 'flex', width: '100%' }}>
                  <span className="post-pymnt-lbl">Attachment:</span>
                  {allData?.effectiveAttachArr?.map((item, i) => (
                    <span key={i} className="post-pymnt-val">
                      <a
                        href={item.path}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item.fileName}
                      </a>
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val width100">
                <span className="post-pymnt-lbl">Note:</span>
                <span className="post-pymnt-val">
                  {allData?.effective_note}
                </span>
              </div>
            </div>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">ID:</span>
                <span className="post-pymnt-val">{allData?.credentialId}</span>
              </div>
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">RCM Ticket Id:</span>
                <span className="post-pymnt-val">{allData?.rcm_id}</span>
              </div>
            </div>
          </fieldset>
          <fieldset>
            <legend>EDI:</legend>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">Status:</span>
                <span className="post-pymnt-val">{allData?.edi_status}</span>
              </div>
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">Note:</span>
                <span className="post-pymnt-val">{allData?.edi_note}</span>
              </div>
            </div>
          </fieldset>
          <fieldset>
            <legend>ERA:</legend>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">Status:</span>
                <span className="post-pymnt-val">{allData?.era_status}</span>
              </div>
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">Note:</span>
                <span className="post-pymnt-val">{allData?.era_note}</span>
              </div>
            </div>
          </fieldset>
          <fieldset>
            <legend>EFT:</legend>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">Status:</span>
                <span className="post-pymnt-val">{allData?.eft_status}</span>
              </div>
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">Note:</span>
                <span className="post-pymnt-val">{allData?.eft_note}</span>
              </div>
            </div>
          </fieldset>
          <fieldset>
            <legend>Portal:</legend>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">URL:</span>
                <span className="post-pymnt-val">
                  {allData?.payer_portal_url}
                </span>
              </div>
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">Status:</span>
                <span className="post-pymnt-val">
                  {allData?.payer_portal_status}
                </span>
              </div>
            </div>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">User:</span>
                <span className="post-nt-val">
                  {allData?.payer_portal_user}
                </span>
              </div>
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">Note:</span>
                <span className="post-pymnt-val">
                  {allData?.payer_portal_note}
                </span>
              </div>
            </div>
            <div className="post-pymnt-rw">
              <div className="post-pymnt-rw-val">
                <span className="post-pymnt-lbl">Pass:</span>
                <span className="post-nt-val">
                  {allData?.payer_portal_pass}
                </span>
              </div>
            </div>
          </fieldset>
        </div>
        <div className="bill-claim-edit-btn-rw">
          <Button
            variant="outline"
            onClick={close}
            style={{ padding: '5px 10px', marginRight: '10px' }}
          >
            Cancel
          </Button>

          <Button
            variant={'primary'}
            onClick={() => {
              close();
              editPopup(id);
            }}
            style={{ padding: '5px 10px' }}
          >
            Edit
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ViewCredentialingPopup;
